import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["label", "collapseIcon", "expandIcon"]
  static values = { expanded: Boolean }

  connect() {
    // Check if user preference is stored
    const userPreference = localStorage.getItem('sidebarExpanded') || false
    if (userPreference !== null) {
      this.expandedValue = userPreference === 'true'
    }

    this.updateSidebar()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    // Store user preference
    localStorage.setItem('sidebarExpanded', this.expandedValue)
    this.updateSidebar()
  }

  updateSidebar() {
    const sidebar = document.querySelector('aside#drawer-navigation')

    if (!sidebar) {
      return
    }

    if (this.expandedValue) {
      sidebar.classList.remove(sidebar.dataset.collapsedClass)
      sidebar.classList.add(sidebar.dataset.expandedClass)
      this.labelTargets.forEach(label => label.classList.remove("hidden"))
      this.collapseIconTarget.classList.remove("hidden")
      this.expandIconTarget.classList.add("hidden")
    } else {
      sidebar.classList.remove(sidebar.dataset.expandedClass)
      sidebar.classList.add(sidebar.dataset.collapsedClass)
      this.labelTargets.forEach(label => label.classList.add("hidden"))
      this.collapseIconTarget.classList.add("hidden")
      this.expandIconTarget.classList.remove("hidden")
    }
  }
}
